import { forwardRef, useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    dropDownFormStyle,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { Select } from 'chakra-react-select';


const InternationalRateWholesalerField = ({ errors, touched, darkMode, wholesalerOptions, onChange }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { createMode } = walkthroughIds;
    const ChakraSelect = forwardRef((props, ref) => (
        <Select selectedOptionColor="brand" ref={ref} {...props} />
    ));
    ChakraSelect.displayName = "ChakraSelect";
    return (
        <FormControl
            isInvalid={!!errors.wholesalerID && touched.wholesalerID}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()} align="center">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Wholesaler
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Choose the wholesaler for this international rate.
                    </Text>
                </Box>
                <Box
                    flex="1"
                    sx={{
                        paddingTop: '15px',
                    }}
                >
                    <Field name="wholesalerID">
                        {({ form }) => {
                            const selectedOption = form.values.wholesalerID
                                ? wholesalerOptions?.find((op) => op.value === form.values.wholesalerID) || null
                                : null;
                            console.log('Selected Wholesaler Option:', selectedOption);
                            return (
                                <ChakraSelect
                                    minWidth="410px"
                                    width="100%"
                                    // data-walkthroughid={createMode.ufSelectiveSyncSelect}
                                    options={wholesalerOptions}
                                    placeholder="- Select Wholesaler -"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    getOptionLabel={(i) => i.label}
                                    getOptionValue={(i) => i.value}
                                    chakraStyles={dropDownFormStyle(darkMode)}
                                    isLoading={form.isSubmitting}
                                    isDisabled={form.isSubmitting}
                                    value={selectedOption}
                                    onChange={(option) => {
                                        if (option) {
                                            // Selecting a wholesaler: update both ID and name
                                            form.setFieldValue('wholesalerID', option.value);
                                            form.setFieldValue('wholesaler', option.label);
                                        } else {
                                            // Clearing: only set ID to null, keep wholesaler name as is
                                            form.setFieldValue('wholesalerID', null);
                                        }
                                        form.validateField('wholesalerID');
                                        if (onChange) {
                                            onChange(form, option ? option.value : null);
                                        }
                                    }}
                                    isClearable
                                    onBlur={() => {
                                        form.setFieldTouched('wholesalerID', true);
                                    }}
                                />
                            );
                        }}
                    </Field>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Choose the wholesaler for this international rate."
                        ariaLabel="international-rate-wholesaler-tip"
                        left="25px"
                        top="10px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default InternationalRateWholesalerField;